import { Card, CardContent, Typography } from '@mui/material'
import React, { useState } from 'react'
import Analytics from '../../pages/analytics'
import { THorse } from '../../shared/types/horse.type'
import { t } from 'i18next'


function HorseAnalytics({ horse, onTrainingIdsChange,date }: { date?:string,horse?: THorse, onTrainingIdsChange?: (ids: number[]) => void }) {


    return (
        <Card>
            <CardContent>
                <Typography variant='h6'>
                    {t('navbar:analytics')}
                </Typography>
                <Analytics
                    onTrainingIdsChange={onTrainingIdsChange}
                    showHeader={false}
                    selectedHorse={horse?.id}
                    date={date}

                />
            </CardContent>
        </Card>
    )
}

export default HorseAnalytics